import { render, staticRenderFns } from "./AdminBusCompanies.vue?vue&type=template&id=3cdc15ec&"
import script from "./AdminBusCompanies.vue?vue&type=script&lang=js&"
export * from "./AdminBusCompanies.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports